import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../core/auth.service';
import { Router } from '@angular/router';
import { confirm, alert } from 'devextreme/ui/dialog';
import { AppInformationService } from 'app/core/core.module';
import { TopNavbarComponent } from 'app/common/topnavbar/topnavbar.component';
import { first } from 'rxjs/operators';

declare var jQuery: any;

@Component({
    standalone: false,
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    model = { userName: '', password: '' };
    church: string;

    constructor(private auth: AuthService, private router: Router, private appInfo: AppInformationService) {}

    ngOnInit() {
        this.auth.logout();
    }

    async login() {
        await this.appInfo.pleaseWaitShow();

        this.auth
            .login(this.model.userName, this.model.password)
            .pipe(first())
            .subscribe({
                next: async () => {
                    try {
                        if (this.auth.currentUser) {
                            this.router.navigate(['/']);
                            this.appInfo.pleaseWaitHide();
                            return;
                        }
                        this.appInfo.pleaseWaitHide();
                        alert('Error logging into server', 'Login Error');
                    } catch (exception) {
                        const ex: any = exception;
                        this.appInfo.pleaseWaitHide();
                        await alert((exception && (ex.error.error_description || ex.message)) || 'Error logging into server', 'Login Error');
                    } finally {
                        this.appInfo.pleaseWaitHide();
                    }
                },
                error: async (exception) => {
                    await alert(exception || 'Error logging into server', 'Login Error');
                    this.appInfo.pleaseWaitHide();
                },
            });
    }
}
